import config from 'config';

const LOAD = 'horse-racing/fast-cards/LOAD';
const LOAD_SUCCESS = 'horse-racing/fast-cards/LOAD_SUCCESS';
const LOAD_FAIL = 'horse-racing/fast-cards/LOAD_FAIL';

const initialState = {
  loaded: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        [action.meetingId]: {
          ...state[action.meetingId],
          loading: true
        }
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        [action.meetingId]: {
          ...state[action.meetingId],
          loading: false,
          loaded: true,
          meeting: action.result
        }
      };
    case LOAD_FAIL:
      return {
        ...state,
        [action.meetingId]: {
          ...state[action.meetingId],
          loading: false,
          loaded: false,
          error: action.error
        }
      };
    default:
      return state;
  }
}

export function isLoading(globalState, meetingId) {
  return globalState.horseRacing
      && globalState.horseRacing.fastCards
      && globalState.horseRacing.fastCards[meetingId]
      && globalState.horseRacing.fastCards[meetingId].loading;
}

export function load(meetingId) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => client.get(config.api.horseRacing.loadFastCard, {params: {meetingId}}),
    meetingId
  };
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/reducers/fastCards.js